module.exports = __webpack_public_path__ + "img/Down report.bcba5089.svg";